export {default as Instagram} from './instagram'



// WEBPACK FOOTER //
// ./src/components/social-media/index.js